import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import SieauAction from '../../../../components/sieau/SieauAction'
import ActionComponent from '../../../../components/ActionComponent'
import DtoMaterielSituation from '../../../../materiel/dto/DtoMaterielSituation'
import { isEqual, keys, omit, orderBy } from 'lodash'
import {
    getStationTitle,
    getStationTitleWithTownName,
    getStationTypeCodeFromType,
    getStationTypeNameFromTypeCode,
} from '../../../../utils/StationUtils'
import DtoMaterielState from '../../../../materiel/dto/DtoMaterielState'
import SituationStationForm from './SituationStationForm'
import moment from 'moment'
import { getUser } from '../../../../utils/SettingUtils'
import { MATERIEL_STATE_ON_SITE_ID } from '../../../../materiel/constants/MaterielStateConstants'
import { createIconMaterialState } from '../../../../utils/MaterielUtils'
import DtoStation from '../../../dto/DtoStation'
import EventsAction from '../../../../events/actions/EventsAction'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid, Stack } from '@mui/material'
import DtoEvent from '../../../../events/dto/DtoEvent'
import { getDate } from '../../../../utils/DateUtil'
import { EVENT_TYPES_CODES } from '../../../../events/constants/EventsConstants'
import InstallationAction from '../../../../installation/actions/InstallationAction'
import DtoInstallationEvent from '../../../../installation/dto/installation/DtoInstallationEvent'
import { getLabel } from '../../../../utils/StoreUtils'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import { CardTable } from 'components/datatable/NewTable'
import { darkBlue } from 'utils/constants/ColorTheme'
import { DefaultDialogTitle } from 'components/styled/Dialog'

class SituationDetailPanel extends ActionComponent {
    state = {
        situation: new DtoMaterielSituation({}),
        isEditMode: false,
        newMaterielSituation: new DtoMaterielSituation({}),
        shouldReplace: false,
        openPopup: false,
        step: 0,
        event: {},
        additionalStepFinish: !this.props.additionalStep || this.props.additionalStep === null,
    }

    componentDidMount() {
        this.setTitle()
        this.initAction()
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.station, this.props.station) || (keys(this.props.citiesIndex).length !== keys(prevProps.citiesIndex).length)) {
            this.setTitle()
        }
        if (this.state.isEditMode !== prevState.isEditMode) {
            this.initAction()
        }
    }

    setTitle = () => {
        const { id, materialType } = this.props.params
        const { type, station } = this.props
        const townName = this.props.citiesIndex[station.townCode]?.name
        this.props.forceFetch('title', [{
            title: i18n[type],
            href: type,
        }, {
            title: getStationTitleWithTownName(station, townName),
            href: `station/${type}/${id}`,
        }, {
            title: i18n.materiels,
            href: `station/${type}/${id}/materiel`,
        }, {
            title: i18n[materialType],
            href: `station/${type}/${id}/materiel/${materialType}`,
        }])
    }

    changeValue = (key, value) => {
        const { keyMaterielId } = this.props
        if (key === keyMaterielId) {
            if (!value) {
                this.props.resetMateriel()
            } else if (value !== this.state.situation[keyMaterielId]) {
                this.props.fetchMateriel(value)
            }
        }
        this.setState({
            situation: {
                ...this.state.situation,
                [key]: value,
            },
        })
    }

    resetSituation = (situation, editMode) => {
        this.props.resetMateriel()
        this.setState({
            situation: situation || this.createNewSituation(false),
            isEditMode: editMode || false,
            newMaterielSituation: new DtoMaterielSituation({}),
            shouldReplace: false,
            openPopup: false,
            step: 0,
        })
    }

    addEvent = (type, id, event) => {
        if (type === 'installation') {
            return this.props.addInstallationEvent(id, event)
        }
        return this.props.addEvent(type, id, event)
    }

    saveSituation = () => {
        const { id } = this.props.params
        const { type } = this.props
        const {
            situation,
            newMaterielSituation,
            shouldReplace,
            step,
        } = this.state

        const situationFormat = (() => {
            const result = {
                ...situation,
                situationDate: +moment(situation.situationDate),
                situationEndDate: situation.situationEndDate ? +moment(situation.situationEndDate) : undefined,
                siteName: `[${this.getStationCode(this.props.station)}] - ${this.props.station.name}`,
            }
            if (!result.situationEndDate && !result.statusCode) {
                return {
                    ...result,
                    statusCode: MATERIEL_STATE_ON_SITE_ID,
                }
            }
            return result
        })()

        if (situation.id) {
            this.props.saveSituation(situationFormat, id, type)
            this.resetSituation()
        } else if (step === 1) {
            this.props.addSituation({
                ...situationFormat,
                siteCode: Number(id),
                siteType: getStationTypeCodeFromType(type),
                statusCode: MATERIEL_STATE_ON_SITE_ID,
            }, id, type)
            if (shouldReplace) {
                this.props.addSituation({
                    ...situation,
                    ...newMaterielSituation,
                    situationDate: +moment(situation.situationDate),
                }, id, type)
            }
            this.props.updateMateriel()
            this.resetSituation()
        } else {
            const event = {
                code: parseInt(id),
                date: situationFormat.situationDate,
                eventType: 'T',
                graph: '0',
                bankExport: '0',
                eventHour: situationFormat.situationDate,
            }
            this.addEvent(type, id, event).then(eventCode => {
                if (eventCode) {
                    this.props.addSituation({
                        ...situationFormat,
                        siteCode: Number(id),
                        siteType: getStationTypeCodeFromType(type),
                        statusCode: MATERIEL_STATE_ON_SITE_ID,
                        eventCode,
                    }, id, type).then(() => {
                        if (shouldReplace) {
                            this.props.addSituation({
                                ...situation,
                                ...newMaterielSituation,
                                siteCode: Number(id),
                                siteType: getStationTypeCodeFromType(type),
                                situationDate: +moment(situation.situationDate),
                                eventCode,
                            }, id, type)
                        }
                    })
                    this.props.updateMateriel()
                    this.resetSituation()
                }
            })
        }
    }

    createNewSituation = (initDate = true) => new DtoMaterielSituation({
        situationDate: initDate ? moment() : undefined,
    })

    deleteSituation = () =>
        this.props.deleteSituation(this.state.situation, this.props.params.id, this.props.type).then(() => {
            this.resetSituation()
        })

    initAction = () => {
        const actions = (() => {
            if (this.state.isEditMode) {
                return (() => {
                    const result = {
                        save: () => {
                            if (this.state.situation.id) {
                                this.saveSituation()
                            } else {
                                this.setState({ openPopup: true })
                            }
                        },
                        cancel: () => {
                            this.resetSituation()
                        },
                    }
                    if (this.state.situation && this.state.situation.id) {
                        return {
                            ...result,
                            delete: () => {
                                this.deleteSituation()
                            },
                        }
                    }
                    return result
                })()
            }
            return {
                new: () => this.newAction(),
            }
        })()
        if (getUser().consultant === '1') {
            this.setActions(omit(actions, ['new', 'save', 'delete']))
        } else {
            this.setActions(actions)
        }
    }

    newAction = () => this.setState({
        situation: this.createNewSituation(),
        isEditMode: true,
    })

    getStationCode = ({ code, designation }) => designation ? `${code}/${designation}` : code

    getMaterielNumber = ({ imei, serialNumber, reference, numLine, id }) => imei || serialNumber || reference || numLine || id || ''

    getMaterialLabel = (mat, materielTypes, keyMaterielType) => {
        const result = this.getMaterielNumber(mat)
        if (mat[keyMaterielType]) {
            const type = materielTypes.find(b => b.id === mat[keyMaterielType])
            if (type) {
                return `${type.label} - ${result}`
            }
        }
        return result
    }

    getMaterielData = () => {
        const { materiels, materielTypes, keyMaterielType } = this.props
        return materiels.map(mat => ({
            id: mat.id,
            label: this.getMaterialLabel(mat, materielTypes, keyMaterielType),
        }))
    }

    changeStateSituation = (materielSituation, situations) => {
        const situation = situations.find(o => o.id === materielSituation.id) || {}
        this.resetSituation(situation, true)
    }

    getValidateButton = step => {
        const {
            situation,
        } = this.state
        const isBlock = step === 1 && !situation.eventCode
        return (
            <Button disabled={isBlock} variant='contained' color='primary' onClick={() => !isBlock && this.saveSituation()} >
                {i18n.validate}
            </Button>
        )
    }

    getFinishAdditionalStepButton = () => {
        return (
            <Button variant='outlined' onClick={() => this.setState({ additionalStepFinish: true })} >
                {i18n.validate}
            </Button>
        )
    }

    render() {
        const {
            stationMaterielAssignments,
            lastSituations,
            materielStates,
            keyMaterielId,
            station,
            contributors,
        } = this.props
        const {
            openPopup,
            step,
            situation,
            shouldReplace,
            newMaterielSituation,
            isEditMode,
        } = this.state
        const materiels = this.getMaterielData()
        const materielsFiltered = materiels.filter(({ id }) => lastSituations.find(({ [keyMaterielId]: idMat, statusCode }) => idMat === id && statusCode === 2))

        const siteName = station.code ? `[${station.code}] ${station.name || ''}` : (station.name || '')
        const datas = orderBy(stationMaterielAssignments, 'id', 'desc').map(sit => {
            const {
                statusCode,
                siteType,
                id,
                materielId,
                comment,
                situationDate,
                situationEndDate,
            } = sit
            const findState = materielStates.find(state => state.code == statusCode) || {}
            const siteTypeFormat = siteType ? getStationTypeNameFromTypeCode(siteType) : ''
            const { label = '' } = materiels.find(({ id: matId }) => matId === materielId) || {}
            const administrator = getLabel(contributors, sit.administratorCode)
            return {
                id,
                siteType: siteTypeFormat ? i18n[siteTypeFormat] : '',
                siteName,
                materiel: label,
                statusCode: createIconMaterialState(findState.label, statusCode),
                comment,
                administrator,
                situationDate: getDate(situationDate),
                situationEndDate: getDate(situationEndDate),
            }
        })
        const materielsOnSite = stationMaterielAssignments.filter(a => !a.situationEndDate).map(a => materiels.find(m => m.id === a[keyMaterielId]))
        const stationEvents = this.props.type === 'installation' ? this.props.installationEvents : this.props.stationEvents
        const stationsEvents = stationEvents.filter(({ eventType }) => eventType === EVENT_TYPES_CODES.PREVENTIVE || eventType === EVENT_TYPES_CODES.CURATIVE)
        const isLast = situation.id ? !!stationMaterielAssignments.find(({ id }) => id === situation.id).situationEndDate : false
        return (
            <>
                <Stack sx={{ width: '100%' }} spacing={10}>
                    <Card>
                        <CardContent>
                            <SituationStationForm
                                situation={situation}
                                materiels={materielsFiltered}
                                shouldReplace={shouldReplace}
                                materielsOnSite={materielsOnSite}
                                newMaterielSituation={newMaterielSituation}
                                onChangeNewMaterielSituation={obj => this.setState(obj)}
                                changeValue={this.changeValue}
                                isEditMode={isEditMode}
                                idKey={keyMaterielId}
                                isLast={isLast}
                            />
                            {this.props.getMaterielPanel(isEditMode)}
                        </CardContent>
                    </Card>
                    <CardTable
                        title={i18n.materielAssignments}
                        color={darkBlue}
                        rows={datas}
                        headers={['siteType', 'siteName', 'materiel', 'statusCode', 'comment', 'administrator', 'situationDate', 'situationEndDate', 'del']}
                        onClick={materielSituation => this.changeStateSituation(materielSituation, stationMaterielAssignments)}
                    />
                </Stack>
                <Dialog
                    fullWidth
                    maxWidth='md'
                    open={openPopup}
                >
                    <DefaultDialogTitle title={i18n.associateAnEvent} onClose={() => this.setState({ openPopup: false, step: 0, additionalStepFinish: !this.props.additionalStep || this.props.additionalStep === null, event: {} })}/>
                    <DialogContent>
                        <Grid sx={{ minHeight: '30%' }}>
                            {
                                (step === 0 && !this.state.additionalStepFinish && this.props.additionalStep) && this.props.additionalStep({ shouldReplace, replaceMat: newMaterielSituation[keyMaterielId] })
                            }
                            {
                                (step === 0 && this.state.additionalStepFinish) && (
                                    <Grid container justifyContent='center'>
                                        <Card sx={{ width: '50%' }}>
                                            <CardContent>
                                                <Stack spacing={2}>
                                                    <Button
                                                        onClick={() => this.setState({ step: 1 })}
                                                        variant='contained'
                                                        disabled={!stationsEvents.length}
                                                    >
                                                        {i18n.assignEvent}
                                                    </Button>
                                                    <Button
                                                        onClick={this.saveSituation}
                                                        variant='contained'
                                                    >
                                                        {i18n.doNotLink}
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )
                            }
                            {
                                step === 1 && (
                                    <Card>
                                        <CardContent>
                                            <Stack>
                                                {
                                                    orderBy(stationsEvents, 'date', 'desc').map((e, i) => (
                                                        <Grid key={e.number}>
                                                            <input
                                                                name='eventGroup'
                                                                type='radio'
                                                                id={i}
                                                                onChange={() => this.setState({
                                                                    situation: {
                                                                        ...situation,
                                                                        eventCode: e.number,
                                                                    },
                                                                    situationMaterialReplace: {
                                                                        ...newMaterielSituation,
                                                                        eventCode: e.number,
                                                                    },
                                                                })}
                                                            />
                                                            <label htmlFor={i}>{getDate(e.date)} - {e.comment}</label>
                                                        </Grid>
                                                    ))
                                                }
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                )
                            }
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        { step === 1 && (
                            <Button onClick={() => this.setState({ step: 0, additionalStepFinish: !this.props.additionalStep || this.props.additionalStep === null, event: {} })} variant='outlined' >
                                {i18n.return}
                            </Button>
                        )}
                        {step !== 0 ? this.getValidateButton(step) : ((!this.state.additionalStepFinish && this.props.additionalStep) && this.getFinishAdditionalStepButton())}
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

SituationDetailPanel.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
        materialType: PropTypes.string,
    }),
    type: PropTypes.string,
    children: PropTypes.element,
    stationMaterielAssignments: PropTypes.arrayOf(PropTypes.object),
    materiels: PropTypes.arrayOf(PropTypes.object),
    lastSituations: PropTypes.arrayOf(PropTypes.object),
    materielTypes: PropTypes.arrayOf(PropTypes.object),
    keyMaterielType: PropTypes.string,
    keyMaterielId: PropTypes.string,
    station: PropTypes.instanceOf(DtoStation),
    getMaterielPanel: PropTypes.func,
    deleteSituation: PropTypes.func,
    addSituation: PropTypes.func,
    saveSituation: PropTypes.func,
    fetchMateriel: PropTypes.func,
    updateMateriel: PropTypes.func,
    resetMateriel: PropTypes.func,
    stationEvents: PropTypes.arrayOf(PropTypes.instanceOf(DtoEvent)),
    installationEvents: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationEvent)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),

    materielStates: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielState)),
    additionalStep: PropTypes.func,
    citiesIndex: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
    })),
}

const mapStateToProps = store => ({
    materielStates: store.MaterielReducer.materielStates,
    stationEvents: store.EventsReducer.stationEvents,
    installationEvents: store.InstallationReducer.installationEvents,
    contributors: store.ContributorReducer.contributors,
    citiesIndex: store.CityReducer.citiesIndex,

})

const mapDispatchToProps = {
    forceFetch: SieauAction.forceFetch,
    addEvent: EventsAction.addEvent,
    addInstallationEvent: InstallationAction.addInstallationEvent,
}

export default connect(mapStateToProps, mapDispatchToProps)(SituationDetailPanel)